import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18SettingG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: "none",
      fillRule: "evenodd",
      stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey300,
      strokeWidth: 1.136,
      d: "M7.251 1.868c.669.73 1.41.945 2.106.86a2.3 2.3 0 0 0 1.243-.56c.405-.383.635-.516.883-.547.335-.04.676.069.93.286.227.195.382.48.394.825-.035.742.215 1.378.624 1.83.443.49 1.075.77 1.773.74.253-.01.479.051.664.165.203.124.358.308.453.518.098.214.135.455.096.69-.035.21-.132.414-.297.589-.547.498-.82 1.124-.85 1.733a2.24 2.24 0 0 0 .731 1.776c.178.163.292.354.346.555a1.212 1.212 0 0 1-.385 1.215 1.1 1.1 0 0 1-.577.254c-.838.07-1.444.308-1.863.628-.538.41-.798.964-.825 1.585-.014.43-.125.768-.314 1.008-.188.24-.45.371-.726.405a1.13 1.13 0 0 1-.908-.291c-.669-.73-1.41-.945-2.106-.86-.45.056-.884.242-1.243.56-.405.383-.636.517-.883.547a1.22 1.22 0 0 1-.93-.286 1.12 1.12 0 0 1-.394-.825c.035-.742-.215-1.378-.624-1.83a2.24 2.24 0 0 0-1.773-.74 1.17 1.17 0 0 1-.665-.165 1.2 1.2 0 0 1-.453-.518 1.2 1.2 0 0 1-.095-.69c.035-.21.132-.414.297-.589.547-.498.82-1.124.85-1.733a2.25 2.25 0 0 0-.731-1.776 1.16 1.16 0 0 1-.346-.555 1.205 1.205 0 0 1 .385-1.215 1.1 1.1 0 0 1 .576-.254c.838-.07 1.445-.307 1.864-.627.538-.411.798-.965.825-1.585.014-.431.125-.77.314-1.01.188-.239.45-.37.726-.404.312-.038.642.048.908.291zm3.263 3.569a3.86 3.86 0 0 0-2.964-.026 3.86 3.86 0 0 0-2.113 2.077 3.86 3.86 0 0 0-.027 2.962 3.86 3.86 0 0 0 2.077 2.114 3.86 3.86 0 0 0 2.963.026 3.86 3.86 0 0 0 2.114-2.077 3.87 3.87 0 0 0 .026-2.964 3.86 3.86 0 0 0-2.077-2.113z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18SettingG$1 = Svg18SettingG;

export { Svg18SettingG$1 as default };
